import React from 'react'
import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useAdditionalItemsToggle} from '../../../hooks/use-additional-items-toggle'
import {CardContainerProps} from './interfaces'
import s from './card-container.scss'

export const CardContainer = ({event, children, stripWidth}: CardContainerProps) => {
  const {hovered, events} = useAdditionalItemsToggle({event})

  return (
    <li style={{marginBottom: stripWidth}} {...events} data-hook={DH.listItem} className={s.container}>
      {children(hovered)}
    </li>
  )
}
